import { APPCONFIG } from '../app.config';

export const APIS = {
    URLS: {
        USER: APPCONFIG.SITE.WEBAPI + 'api/user',
        LOGIN: APPCONFIG.SITE.WEBAPI + 'api/login'
    }
}
